export default __webpack_public_path__ + "static/media/desk-clean2.93e5d0f1.png";